module.exports = __webpack_public_path__ + "assets/img/7fe3-ma.svg";